import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { CustomerService } from 'src/app/services/customer.service';
import { faUserCircle, faBuilding } from '@fortawesome/free-regular-svg-icons';
import { faSearch, faUsers, faUser, faPlus } from '@fortawesome/free-solid-svg-icons';
import { ClienteComponent } from '../../popup/cliente/cliente.component'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EliminaComponent } from 'src/app/popup/elimina/elimina.component';
import { ExceluploadComponent } from 'src/app/popup/excelupload/excelupload.component';
import { OpenfolderComponent } from 'src/app/popup/openfolder/openfolder.component';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { partition } from 'rxjs/operators';

@Component({
  selector: 'app-operator',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css']
})

export class CustomerComponent implements OnInit {
  //string
  genderGlobal: string;
  token: string;
  selectedOP: string;
  fname: string;
  fnameChange: string;
  stringChange: string;
  _listFilter = '';

  //any
  tempUser: any;

  //number
  id: number;
  profile: number;
  c = 1;
  disponibility: number;

  //Oggetto
  obj: any = {};
  objUpdate: any = {};
  selectedCustomer: any = {};
  activeUser: any = {};

  //Array
  id_profile: Array<any> = [];
  customer: Array<any> = [];
  descrizione: Array<any> = [];
  filteredCustomers: Array<any> = [];
  address: Array<any> = [
    {
      via: '',
      city: '',
      province: '',
      country: '',
      cap: '',
      residence: false,
      domicile: false
    }
  ];


  //Boolean
  popupSet = false;
  sesso = false;
  del_update = false;
  vero = true;
  new = true;
  choose: boolean;
  form = true;
  fisic = false;
  legal = false;
  card = true;
  indirizzo: boolean = false;
  iva: boolean;
  partIva: boolean;

  change = false;

  nome: boolean;
  cognome: boolean;
  email: boolean;
  vat: boolean;
  rSociale: boolean;

  //Icone
  faUserCircle = faUserCircle;
  faBuilding = faBuilding;
  faSearch = faSearch;
  faUsers = faUsers;
  faUser = faUser;
  faPlus = faPlus;


  constructor(
    private customerService: CustomerService,
    private globals: GlobalService,
    private modalService: NgbModal
  ) {
    this.filteredCustomers = this.customer;
  }

  ngOnInit() {
    this.globals.checkPage(2);
    if (!this.token) {
      this.token = this.globals.getToken();
    }
    this.getCustomer();
    this.newUser();
    this.activeUser = this.globals.storagedUser;
    this.getDisponibility();
  }

  reload() {
    this.tempUser = null;
    this.getCustomer();
    this.newUser();
    this.form = true;
    this.fisic = false;
    this.legal = false;
    this.card = true;
    this.popupSet = false;
    this.sesso = false;
    this.del_update = false;
    this.vero = true;
    this.new = true;
    this.ngOnInit();
    this.address = [];
  }

  get listFilter(): string {
    return this._listFilter;
  }

  set listFilter(value: string) {
    this._listFilter = value;
    this.filteredCustomers = this.listFilter ? this.doFilter(this.listFilter) : this.customer;
  }

  doFilter(filterBy: string) {
    filterBy = filterBy.toLocaleLowerCase();
    return this.customer.filter((operator) =>
      operator.description.toLocaleLowerCase().indexOf(filterBy) !== -1);
  }

  getCustomer() {
    this.customerService.getCustomer(this.token).subscribe(
      res => {
        if (res.error) {
          return this.globals.errorSniffer(res.error);
        } else {
          this.customer = res;
          // Creo il campo descrizione per il campo di ricerca
          this.customer.forEach(custo => {
            if (custo.type == 'FPI' || custo.type == 'FLA' || custo.type == 'FNI') {
              custo.description = `${custo.code} ${custo.email} ${custo.last_name} ${custo.name} ${custo.last_name} ${custo.code} ${custo.email} ${custo.last_name} ${custo.name} ${custo.last_name} ${custo.code} ${custo.last_name} ${custo.name} ${custo.last_name} ${custo.email} ${custo.email} ${custo.code} ${custo.last_name} ${custo.name} ${custo.last_name} ${custo.email}  ${custo.code} ${custo.email} ${custo.code} ${custo.name} ${custo.last_name} ${custo.name} ${custo.email} ${custo.name} ${custo.last_name} ${custo.name} ${custo.code}`;
            }
            if (custo.type == 'GIU') {
              custo.description = `${custo.code} ${custo.email} ${custo.business_name} ${custo.vat} ${custo.email} ${custo.code} ${custo.vat} ${custo.business_name} ${custo.email} ${custo.code} ${custo.business_name} ${custo.code} ${custo.email} ${custo.vat} ${custo.code} ${custo.business_name} ${custo.email}  ${custo.vat} ${custo.code} ${custo.vat} ${custo.business_name}`;
            }
          })
          // Setto il filtro per la ricerca a campo vuoto
          this.listFilter = '';
        }
      },
      err => {
        console.error("Errore in getOperators", err);

      }
    )
  }

  newUser() {
    this.choose = false;
    this.form = true;
    this.customerService.getCustomerProfile(this.token).subscribe(
      res => {
        this.id_profile = res;
        let i = 0;
        this.id_profile.forEach(element => {
          if (element.profile_name == 1) {
            this.descrizione[i] = element.description;
            i++;
          }
        });
      },
      err => {
        console.error("Errore in getProfile: ", err);

      }
    )
  }

  getACustomer(id) {
    this.customerService.getACustomer(this.token, id).subscribe(
      res => {
        this.selectedCustomer = res.customer;
        let date = new Date(this.selectedCustomer.birth_date);

        if (date.getMonth() + 1 > 10 && date.getDate() >= 10) {
          this.selectedCustomer.birth_date = '' + date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + (date.getDate());
          // console.log("mese e giorno >10")
        } else {

          if (date.getMonth() + 1 < 10 && date.getDate() < 10) {
            this.selectedCustomer.birth_date = '' + date.getFullYear() + '-' + '0' + (date.getMonth() + 1) + '-' + '0' + (date.getDate());
            // console.log("mese e giorno <10")
          } else {

            if (date.getMonth() + 1 < 10) {
              this.selectedCustomer.birth_date = '' + date.getFullYear() + '-' + '0' + (date.getMonth() + 1) + '-' + (date.getDate());
              // console.log("mese <10")
            }

            if (date.getDate() < 10) {
              this.selectedCustomer.birth_date = '' + date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '0' + (date.getDate());
              // console.log("giorno <10")
            }
          }
        }
        this.address = res.address;
      },
      err => {
        console.error("Errore: ", err);
      }
    )
  }

  changeStatus() {
    if (this.tempUser) {
      var elementTwo = document.getElementById(this.tempUser);
      elementTwo.classList.remove("color-change")
    }
    this.fisic = false;
    this.legal = false;
    this.choose = true;
    this.selectedCustomer = {}
    this.del_update = false;
    this.new = true;
    this.form = false;
    this.card = false;
    this.fname = null;
    this.fnameChange = null;
    // this.choose = true;
    // this.fisic = true;
  }

  showFormCus(cus) {
    this.svuotalabel();
    if ($("#checkbox").prop("checked", true)) {
      // Uncheck
      $("#checkbox").prop("checked", false);
    }
    this.change = false;
    this.indirizzo = false;

    // let date = new Date(cus.birth_date);
    // if (date.getMonth() + 1 > 10 && date.getDate() >= 10) {
    //   cus.birth_date = '' + date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + (date.getDate());
    //   // console.log("mese e giorno >10")
    // } else {

    //   if (date.getMonth() + 1 < 10 && date.getDate() < 10) {
    //     cus.birth_date = '' + date.getFullYear() + '-' + '0' + (date.getMonth() + 1) + '-' + '0' + (date.getDate());
    //     // console.log("mese e giorno <10")
    //   } else {

    //     if (date.getMonth() + 1 < 10) {
    //       cus.birth_date = '' + date.getFullYear() + '-' + '0' + (date.getMonth() + 1) + '-' + (date.getDate());
    //       // console.log("mese <10")
    //     }

    //     if (date.getDate() < 10) {
    //       cus.birth_date = '' + date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '0' + (date.getDate());
    //       // console.log("giorno <10")
    //     }
    //   }
    // }


    if (this.tempUser) {
      var elementTwo = document.getElementById(this.tempUser);
      elementTwo.classList.remove("color-change")
    }
    this.getACustomer(cus.customer_id);
    var element = document.getElementById(`customer${cus.customer_id}`);
    element.classList.add("color-change");
    this.tempUser = `customer${cus.customer_id}`;
    this.card = false;
    this.change = true;
    this.popupSet = true;
    this.objUpdate = cus;
    this.del_update = true;
    this.choose = true;
    this.new = false;
    this.selectedCustomer = cus;

    this.id = cus.user_id;
    this.form = true;
    if (cus.type == 'FNI' || cus.type == 'FLA' || cus.type == 'FPI') {
      this.fisic = true;
      this.legal = false;
    }
    if (cus.type == "GIU") {
      this.legal = true;
      this.fisic = false;
    }

  }

  svuota(type) {
    this.selectedCustomer.folder_name = {};
    this.fname = null;
    this.fnameChange = null;
    this.change = false;
    this.selectedCustomer = {};
    this.selectedCustomer.type = type;
  }

  select(selectPerson) {

    this.svuotalabel();

    if ($("#checkbox").prop("checked", true)) {
      // Uncheck
      $("#checkbox").prop("checked", false);
    }
    this.change = false;


    this.changeStatus();
    if (selectPerson == 'FNI' || selectPerson == 'FLA' || selectPerson == 'FPI') {
      this.fisic = true;
      this.legal = false;
      this.selectedCustomer.type = selectPerson;
      this.svuotalabel();
    }
    if (selectPerson == "GIU") {
      this.legal = true;
      this.fisic = false;
      this.selectedCustomer.type = selectPerson;
      this.svuotalabel();
    }
    this.address = [];

    if (this.selectedCustomer.type == "FLA" || this.selectedCustomer.type == "FPI" || this.selectedCustomer.type == "GIU") {
      this.partIva = true;
    } else {
      this.partIva = false;
    }
  }

  delProfile(user) {
    const modalRef = this.modalService.open(EliminaComponent, { backdrop: 'static', centered: true })
    modalRef.componentInstance.token = this.token;
    modalRef.componentInstance.user = user;

    modalRef.result.then((result) => {
      if (result != 'cancel') {
        let element = document.getElementById(`customer${result}`);
        element.classList.remove("color-change")
        this.tempUser = null;
        this.reload();
      }
    }, reason => {
    });
  }

  updateProfile(customerComplete) {

    if (customerComplete.type == 'FLA' || customerComplete.type == 'FPI' || customerComplete.type == 'FNI') {
      if (customerComplete.name) {
        this.nome = true;
        document.getElementById("cusName").innerHTML = "";
      } else {
        this.nome = false;
        document.getElementById("cusName").innerHTML = "↓ Il campo è obbligatorio";
      }

      if (customerComplete.last_name) {
        this.cognome = true;
        document.getElementById("cusLast_Name").innerHTML = "";
      } else {
        this.cognome = false;
        document.getElementById("cusLast_Name").innerHTML = "↓ Il campo è obbligatorio";
      }
    } else {
      if (customerComplete.type == 'GIU') {
        if (customerComplete.business_name) {
          this.rSociale = true;
          document.getElementById("cusBusinessName").innerHTML = "";
        } else {
          this.rSociale = false;
          document.getElementById("cusBusinessName").innerHTML = "↓ Il campo è obbligatorio";
        }
      }
    }
    if (customerComplete.email) {
      this.email = true;
      document.getElementById("cusEmail").innerHTML = "";
    } else {
      this.email = false;
      document.getElementById("cusEmail").innerHTML = "↓ Il campo è obbligatorio";
    }

    if (customerComplete.vat) {
      this.vat = true;
      document.getElementById("CF").innerHTML = "";
    } else {
      this.vat = false;
      document.getElementById("CF").innerHTML = "↓ Il campo è obbligatorio";
    }

    if (((this.nome && this.cognome) || this.rSociale) && this.email && this.email) {
      if (customerComplete.type == 'FLA' || customerComplete.type == 'FPI' || customerComplete.type == 'GIU') {
        if (this.iva) {


          delete customerComplete["description"];
          let updateUbj = {
            customer: customerComplete,
            address: this.address
          }

          updateUbj.address.forEach((addres) => {
            if (addres.residence) {
              addres.residence = 'Y';
            } else {
              addres.residence = 'N';
            }

            if (addres.domicile) {
              addres.domicile = 'Y';
            } else {
              addres.domicile = 'N';
            }

          });

          this.customerService.updateCustomer(this.token, customerComplete.customer_id, updateUbj).subscribe(
            res => {
              if (this.change == false) {
                this.customerService.updateFolderName(this.token, customerComplete.folder_id, { name: customerComplete.folder_name }).subscribe(
                  res => {
                    this.reload();
                  },
                  err => {
                    console.error("Errore in updateFolderName: ", err);
                  }
                )
              } else {
                this.reload();
              }
              this.getCustomer()
            },
            err => {
              console.error("Errore in updateUser", err);

            }
          )
        }
      }
    }
  }

  onChange(cognome, nome, business, code) {
    if (this.change == false) {
      if (!cognome) cognome = ''
      if (!nome) nome = ''
      if (!business) business = ''
      if (!code) code = ''
      if (this.legal) {
        this.selectedCustomer.folder_name = `${code}-${business}`;
        this.fname = this.selectedCustomer.folder_name;
        this.fnameChange = this.fname;
      } else {
        this.selectedCustomer.folder_name = `${code}-${cognome} ${nome}`;
        this.fname = this.selectedCustomer.folder_name;
        this.fnameChange = this.fname;

      }
    } else {
      if (!cognome) cognome = ''
      if (!nome) nome = ''
      if (!business) business = ''
      if (!code) code = ''
      if (this.legal) {
        this.selectedCustomer.folder_name = `${code}-${business}`;
        this.fnameChange = this.selectedCustomer.folder_name;
        this.fname = this.fnameChange;
      } else {
        this.selectedCustomer.folder_name = `${code}-${cognome} ${nome}`;
        this.fnameChange = this.selectedCustomer.folder_name;
        this.fname = this.fnameChange;
      }
    }
  }

  confirmCustomer(customer, fName) {
    // if (this.fisic=true) {
    //   customer.type = 'F'
    // } else {
    //   if (this.legal=true) {
    //     customer.type = 'G'
    //   }
    // }
    if (customer.type == 'FLA' || customer.type == 'FPI' || customer.type == 'FNI') {
      if (customer.name) {
        this.nome = true;
        document.getElementById("cusName").innerHTML = "";
      } else {
        this.nome = false;
        document.getElementById("cusName").innerHTML = "↓ Il campo è obbligatorio";
      }

      if (customer.last_name) {
        this.cognome = true;
        document.getElementById("cusLast_Name").innerHTML = "";
      } else {
        this.cognome = false;
        document.getElementById("cusLast_Name").innerHTML = "↓ Il campo è obbligatorio";
      }
    } else {
      if (customer.type == 'GIU') {
        if (customer.business_name) {
          this.rSociale = true;
          document.getElementById("cusBusinessName").innerHTML = "";
        } else {
          this.rSociale = false;
          document.getElementById("cusBusinessName").innerHTML = "↓ Il campo è obbligatorio";
        }
      }
    }
    if (customer.email) {
      this.email = true;
      document.getElementById("cusEmail").innerHTML = "";
    } else {
      this.email = false;
      document.getElementById("cusEmail").innerHTML = "↓ Il campo è obbligatorio";
    }

    if (customer.f_code) {
      this.vat = true;
      document.getElementById("CF").innerHTML = "";
    } else {
      this.vat = false;
      document.getElementById("CF").innerHTML = "↓ Il campo è obbligatorio";
    }

    if (customer.type == 'FLA' || customer.type == 'FPI' || customer.type == "GIU") {
      if (customer.vat) {
        this.iva = true;
        document.getElementById("piva").innerHTML = "";
      } else {
        this.iva = false;
        document.getElementById("piva").innerHTML = "↓ Il campo è obbligatorio";
      }

      if (((this.nome && this.cognome) || this.rSociale) && this.email && this.email && this.vat) {
        if (((this.nome && this.cognome) || this.rSociale) && this.email && this.email) {
          if (customer.type == 'FLA' || customer.type == 'FPI' || customer.type == 'GIU') {
            if (this.iva) {
              const modalRef = this.modalService.open(ClienteComponent, { backdrop: 'static', size: 'xl' })
              modalRef.componentInstance.customer = customer;
              modalRef.componentInstance.folderName = fName;
              modalRef.componentInstance.address = this.address
              modalRef.result.then(result => {
                if (result == 'cancel') {
                } else {
                  this.reload();
                  this.selectedCustomer = {};
                  this.choose = false;
                }
              }, (reason) => {
              });
            }
          }
        }
      }
    }
  }

  svuotalabel() {
    if (document.getElementById("cusEmail")) {
      document.getElementById("cusEmail").innerHTML = "";
    }
    if (document.getElementById("CF")) {
      document.getElementById("CF").innerHTML = "";
    }
    if (document.getElementById("cusLast_Name")) {
      document.getElementById("cusLast_Name").innerHTML = ""
    }
    if (document.getElementById("cusBusinessName")) {
      document.getElementById("cusBusinessName").innerHTML = ""
    }
    if (document.getElementById("cusName")) {
      document.getElementById("cusName").innerHTML = ""
    }
  }

  changeDisable() {
    if (this.change == true) {
      this.change = false;
    } else {
      this.change = true;
    }
  }

  aggiornaPopup() {

    const modalRef = this.modalService.open(ClienteComponent, { backdrop: 'static', size: 'xl' })
    modalRef.componentInstance.customer = this.objUpdate;
    modalRef.result.then(result => {
    })
  }

  getDisponibility() {
    this.customerService.getDisponibility(this.token).subscribe(
      res => {
        this.disponibility = res.disponibility;
      },
      err => {
        console.error("Error on get disponibility", err);
      }
    )
  }

  // doFilter(filterBy: string) {
  //   filterBy = filterBy.toLocaleLowerCase();
  //   return this.customer.filter((operator) =>
  //     operator.description.toLocaleLowerCase().indexOf(filterBy) !== -1);
  // }

  addAddress() {
    if (this.address.length <= 15) {
      let obj = {
        via: '',
        city: '',
        province: '',
        country: '',
        cap: '',
        residence: false,
        domicile: false
      }
      this.address.push(obj);
      if (this.address.length >= 1) {
        this.indirizzo = true;
      }
    } else {
      console.error("Numero massimo di inidrizzi raggiunto");
    }
  }

  residence(ad) {
    ad.residence ? ad.residence = true : ad.residence = false
  }

  domicile(ad) {
    ad.domicile ? ad.domicile = true : ad.domicile = false
  }

  deleteAddres(add) {
    this.address.splice(this.address.indexOf(add), 1);
    if (this.address.length < 1) {
      this.indirizzo = false;
    }
  }

  addExcelPop() {
    const modalRef = this.modalService.open(ExceluploadComponent, { backdrop: 'static', size: 'xl', centered: true })
    modalRef.result.then(result => {
      if (result != 'cancel') {
        this.reload();
      }
    }, reason => {
    });
  }

  openCustomerfolder() {
    const modalRef = this.modalService.open(OpenfolderComponent, { backdrop: 'static', centered: true, size: 'xl' })
    modalRef.componentInstance.folder_id = this.selectedCustomer.folder_id;
    modalRef.result.then(result => {
      if (result != 'cancel') {
        this.getCustomer();
        this.newUser();
      }
    }, reason => {
    });
  }
}